module.exports = __webpack_public_path__ + "assets/2bbc715fe3733c610c7c4facfe1a9b95.png";